import { render, staticRenderFns } from "./MessengerAppTitle.vue?vue&type=template&id=4d02a24d&scoped=true&"
var script = {}
import style0 from "./MessengerAppTitle.vue?vue&type=style&index=0&id=4d02a24d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d02a24d",
  null
  
)

export default component.exports